import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import maskData from "../data/maskData";

export default function Mask() {
  const { t } = useTranslation();
  useScrollAnimation();

  const showData = maskData.map((el, index) => (
    <div key={index} className="w-full shadow-md px-5 py-2 rounded">
      <div className="font-bold capitalize text-[#017E89]">
        {t(`${el.name}`)}
      </div>
    </div>
  ));

  return (
    <section className="relative py-[40px]">
      {/* العنوان الرئيسي */}
      <div className="flex flex-col items-center justify-center mx-auto w-fit text-center">
        <div className="js-scroll fade-top w-[90px] h-[30px]">
          <img
            className="w-full h-full"
            src={require("../../assets/icons/lineMainTitle.svg").default}
            alt=""
          />
        </div>
        <div className="js-scroll fade-btm text-[25px] md:text-[35px] font-bold uppercase text-[#017E89]">
          {t("B-Yosef (B-Complex ) INJ 10 Amp")}
        </div>
        <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
      </div>

      {/* المحتوى */}
      <div className="container flex flex-col gap-[15px] items-center py-[30px]">
        {/* بالـ md (شاشات كبيرة) بتكون صفين, بالموبايل عمود */}
        <div className="f-fol flex flex-col md:flex-row justify-between gap-[20px] w-full">
          {/* الصورة */}
          <div className="w-full md:w-[48%] flex justify-center">
            <img
              className="w-[90%] h-auto object-contain"
              src={require("../../assets/image/byousf.svg").default}
              alt=""
            />
          </div>

          {/* النصوص */}
          <div className="w-full md:w-[48%] flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[5px]">{showData}</div>
            <Link to={"/howToUse"} className="flex flex-col gap-1">
              <span className="capitalize text-[#017E89] font-semibold">
                {t("How to Use for all")}
              </span>
              <img
                className="h-auto w-[60px]"
                src={require("../../assets/icons/twoLines.svg").default}
                alt=""
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
